import { useAuth } from 'src/auth/AuthContext';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const SuperAdminRoute: React.FC = () => {
  const user = useAuth();

  if (!user.isSuperAdmin) {
    return <Navigate to="/locations" />;
  }

  return <Outlet />;
};

export default SuperAdminRoute; 